import { OwnerRecordNoKeysSchema } from '../../db/ownerRecord.js';
export const GetDefaultOwnerApiSchema = {
    response: OwnerRecordNoKeysSchema,
};
export const GetDefaultOwnerResponseSchema = GetDefaultOwnerApiSchema.response;
